import React, { useState } from 'react';
import { Input, Tabs, Typography } from 'antd';
import { EditOutlined, EyeOutlined } from '@ant-design/icons';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const { TextArea } = Input;
const { Text } = Typography;

/**
 * Markdown preview + source editor (same pattern as AI market report).
 */
const EditableMarkdownContent = ({
  value,
  onChange,
  minRows = 14,
  defaultTab = 'preview',
}) => {
  const [activeTab, setActiveTab] = useState(defaultTab);

  return (
    <Tabs
      activeKey={activeTab}
      onChange={setActiveTab}
      items={[
        {
          key: 'preview',
          label: (
            <span>
              <EyeOutlined /> Preview
            </span>
          ),
          children: (
            <div
              className="af-markdown-preview"
              style={{
                background: '#fff',
                padding: '16px 20px',
                border: '1px solid #e8e8e8',
                borderRadius: 8,
              }}
            >
              {value?.trim() ? (
                <ReactMarkdown remarkPlugins={[remarkGfm]}>{value}</ReactMarkdown>
              ) : (
                <Text type="secondary">Nothing to preview yet.</Text>
              )}
            </div>
          ),
        },
        {
          key: 'edit',
          label: (
            <span>
              <EditOutlined /> Edit
            </span>
          ),
          children: (
            <>
              <Text type="secondary" style={{ display: 'block', marginBottom: 8, fontSize: 12 }}>
                Edit the report text below using markdown (**bold**, ## headings, - lists). Open
                Preview to see the formatted layout.
              </Text>
              <TextArea
                value={value}
                onChange={(e) => onChange(e.target.value)}
                autoSize={{ minRows, maxRows: 32 }}
                style={{ fontFamily: 'inherit', fontSize: 14 }}
              />
            </>
          ),
        },
      ]}
    />
  );
};

export default EditableMarkdownContent;
